import React from 'react'
import styled from 'styled-components'

const ContainerDiv = styled.div`
  margin-top: ${props => props.marginT}px;
  margin-bottom: ${props => props.marginB}px;
  margin-left: ${props => props.marginL}px;
  margin-right: ${props => props.marginR}px;
  padding-top: ${props => props.paddingT}px;
  padding-bottom: ${props => props.paddingB}px;
  padding-left: ${props => props.paddingL}px;
  padding-right: ${props => props.paddingR}px;
`

const Container = ({
  children,
  marginT = 0,
  marginB = 0,
  marginL = 0,
  marginR = 0,
  paddingT = 0,
  paddingB = 0,
  paddingL = 0,
  paddingR = 0,
  className,
}) => {
  return (
    <ContainerDiv
      marginT={marginT}
      marginB={marginB}
      marginL={marginL}
      marginR={marginR}
      paddingT={paddingT}
      paddingB={paddingB}
      paddingL={paddingL}
      paddingR={paddingR}
      className={className}
    >
      {children}
    </ContainerDiv>
  )
}

export default Container
